import axios from 'axios';
import config from '../config';

const API_URL = `${config.API_BASE_URL}/filters`;

export const fetchFilters = async () => {
  const res = await axios.get(API_URL);
  return res.data;
};

export const createFilter = async (data) => {
  const res = await axios.post(API_URL, data);
  return res.data;
};

export const updateFilter = async (id, data) => {
  const res = await axios.put(`${API_URL}/${id}`, data);
  return res.data;
};

export const deleteFilter = async (id) => {
  const res = await axios.delete(`${API_URL}/${id}`);
  return res.data;
};

// Helper to convert file to base64
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};
